module.exports = __webpack_public_path__ + "img/4.b3c5196a.jpg";